import { Stack } from "@mui/material";
import { Card, Typography } from "@platform/design-system";

import { LaunchpadSection } from "../LaunchpadSection";

import type { CoverageSection } from "../../types";

interface Props {
  sections: readonly CoverageSection[];
}

/**
 * One section per quoted coverage. Findings are bullets, one concise line
 * each, rather than a paragraph.
 */
const CoverageLines = ({ sections }: Props): React.JSX.Element => (
  <Card title="By Line of Coverage" variant="outlined" padding="condensed">
    <Stack spacing={1}>
      {sections.map((section) => (
        <LaunchpadSection
          key={section.id}
          data-testid={`launchpad-section-${section.id}`}
          title={section.title}
          state={section.state}
          metas={section.metas}
          link={section.link}
        >
          <Stack component="ul" spacing={0.5} sx={{ m: 0, pl: 3 }}>
            {section.findings.map((finding) => (
              <Typography component="li" variant="body-medium" key={finding}>
                {finding}
              </Typography>
            ))}
          </Stack>
        </LaunchpadSection>
      ))}
    </Stack>
  </Card>
);

export { CoverageLines };
export type { Props as CoverageLinesProps };
